/***********************************
Menu Module
************************************/

Quad.InvestorSECFilings = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    var path = window.location.href.split( '/' );
    path = path[ 0 ]+'//'+path[ 2 ];

    function SECsearch( offset, type, topic, query, loadMore ){

      // type = year
      // topic = group

      var requestUrl = path+'/wp-json/investor-relations/v1/filings?size=20';
      
      if( loadMore ){ requestUrl = requestUrl +'&page='+ offset; }
      else if( type || topic ){ requestUrl = requestUrl +'&year='+type+'&group='+topic; }

      $.get( requestUrl, function( data ){

            if( !loadMore ){
              $('#resource-table-content').empty();
              $('.current-count').text( '20' );
            } else {
              $('.current-count').text( offset*20 );
            }

            $( '#sec-pagination .total' ).text( data.total );

            if( data.items.length > 0 ){
              for ( var i = 0; i < data.items.length; i++ ){

                var id          = data.items[i].id,
                    date        = data.items[i].dateFiled,
                    formType    = data.items[i].formType,
                    description = data.items[i].description,
                    filingGroup = data.items[i].formGroup,
                    htmlUrl     = data.items[i].formats.html && data.items[i].formats.html.url,
                    xbrlUrl     = data.items[i].formats.xbrl && data.items[i].formats.xbrl.url,
                    htmlUrlLink = data.items[i].formats.html && data.items[i].formats.html.self
                    formatsHtml = '';

                    date = date.replace(/-/g,'/');

                var dateYear  = date.substr( 0,4 ),
                    dateMonth = date.substr( 5,7 );

                    date = dateMonth+'/'+dateYear;

                if ( htmlUrl ) {
                  formatsHtml +=
                    '<a class="resource-icon" href="'+htmlUrl+'" target="_blank">'+
                      '<span class="icon icon-page"></span>'+
                      '<small>HTML</small>'+
                    '</a>';
                } else if ( htmlUrlLink ) {
                  formatsHtml +=
                    '<a class="resource-icon resource-loader" href="#'+id+'" target="_blank" data-link="'+htmlUrlLink+'">'+
                      '<span class="icon icon-page"></span>'+
                      '<small>HTML</small>'+
                      '<span class="loading-indicator"></span>'
                    '</a>';
                }
                if( xbrlUrl ){
                  formatsHtml +=
                    '<a class="resource-icon" href="'+xbrlUrl+'" target="_blank">'+
                      '<span class="icon icon-page"></span>'+
                      '<small>XBRL</small>'+
                    '</a>';
                }

                $('#resource-table-content').append(

                  '<article class="resource">'+
                    '<div class="col-1">'+date+'</div>'+
                    '<div class="col-2">'+formType+'</div>'+
                    '<div class="col-3">'+description+'</div>'+
                    '<div class="col-4">'+filingGroup+'</div>'+
                    '<div class="col-5">'+formatsHtml+'</div>'+
                  '</article>'

                );

              }
            }

            $( '.pagination button' ).removeClass( 'loading' );

            // Load the format URL on the click of any filing marked as a resource-loader
            $( '.resource-loader' ).on('click', function (e) {
              var element = $(this);

              var link = element.data('link');
              if (link == null) {
                return true;
              }

              // Cancel the click event
              e.preventDefault();
              e.stopPropagation();

              // Display loading icon and get the url for the filing, then
              // clean up the resource loader state and open the filing when done
              element.addClass('loading');
              $.get(link, function (response) {
                element.attr('href', response.url);
                element.remove('.loading-indicator');
                element.removeClass('resource-loader loading');
                window.open(response.url, '_blank');
              });
            });
          }
      );

      $( '#resource-table .loading-results' ).hide();
    }

    SECsearch();

    function _setYearOptions(){

      $.get( path+'/wp-json/investor-relations/v1/filings/years', function( data ){

        data.reverse();

        for( var i = 0; i < data.length; i ++ ){

          $( '#sec-year-filter' ).append(
            '<label for="'+data[i].id+'">'+
              '<input class="resource-filter" name="year[]" type="checkbox" id="'+data[i].id+'" value="'+data[i].id+'" />'+
              '<span>'+data[i].label+'</span>'+
            '</label>'
          );

        }

        $( 'form .loading-indicator' ).hide();

        $( 'input' ).iCheck({
          checkboxClass: 'icheckbox',
          radioClass: 'iradio'
        });

      });

    }

    _setYearOptions();

    function _setGroupOptions(){

      $.get( path+'/wp-json/investor-relations/v1/filings/groups', function( data ){

        for( var i = 0; i < data.length; i ++ ){

          $( '#sec-resource-filter' ).append(
            '<label for="'+data[i].id+'">'+
              '<input class="resource-filter" name="group[]" type="checkbox" id="'+data[i].id+'" value="'+data[i].id+'" />'+
              '<span>'+data[i].label+'</span>'+
            '</label>'
          );

        }

        $( 'form .loading-indicator' ).hide();

        $( 'input' ).iCheck({
          checkboxClass: 'icheckbox',
          radioClass: 'iradio'
        });

      });

    }

    _setGroupOptions();


    function filterMatchHeight() {
      var resultHeight = $( '#filter-match' ).height();
      $( '#filter' ).css( 'min-height', resultHeight );
    }
    $( document ).ready( function(){ filterMatchHeight(); });
    $( window ).resize( function(){ filterMatchHeight(); });


    /*
    *
    * NOTES: In the WP API, multi post type search is fed through array, categories are simple comma-separated strings
    *
    * Global search settings, offset pagination, etc.
    *
    */


    var topics = [], allTopics, medias = [], allMedia;

    $( 'input[name="group[]"]' ).each( function( i ) {
      topics[ i ] = $( this ).val();
    });
    allTopics = topics.join( ', ' );

    $( 'input[name="year[]"]' ).each( function( i ) {
      medias[ i ] = $( this ).val();
    });
    //allMedia = JSON.stringify( medias );
    allMedia = medias.join( ', ' );

    function getAllMedia() {
      var medias = [], allMedia;
      $( 'input[name="year[]"]' ).each( function( i ) {
        medias[ i ] = $( this ).val();
      });
      return JSON.stringify( allMedia );
    }

    var pageOffset = 1,
        offset = 0;

    /* Load More business logic */

    $( '.pagination button' ).click( function() {

      var query = $( '.resource-main-search input' ).val();
      var topic = [];
      $( 'input[name="group[]"]:checkbox:checked' ).each( function( i ) {
        topic[ i ] = $( this ).val();
      });
      topic = topic.toString();
      topic = topic.replace( /,/g, ',' );
      var topics = [];
      $( 'input[name="group[]"]' ).each( function( i ) {
        topics[ i ] = $( this ).val();
      });
      var allTopics = topics.toString();
      allTopics = allTopics.replace( /,/g, ',' );
      var mediaType = [];
      $( 'input[name="year[]"]:checkbox:checked' ).each( function( i ) {
        mediaType[ i ] = $( this ).val();
      });
      JSON.stringify( mediaType );
      var medias = [];
      $( 'input[name="year[]"]' ).each( function( i ) {
        medias[ i ] = $( this ).val();
      });
      JSON.stringify( medias );

      topic.length === 0 ? topic = allTopics : topic;
      mediaType.length === 0 ? mediaType = medias : mediaType;

      $( this ).addClass( 'loading' );

      // TODO: Offset keeps racking up, but it should be reset with fresh queries

      pageOffset += 1,
      offset += 20;

      //offset,type,topic,query,isLoadMore

      SECsearch( pageOffset, mediaType, topic, null, true );

    });

    /* Checkboxes, part 1: Parsing query strings if applicable */

    if ( typeof type_filter === 'object' && type_filter.length !== null ) {
      var typeLength = type_filter.length;
      for ( var i = 0; i < typeLength; i++ ) {
        $( '.resource-filter[value="'+ type_filter[ i ] +'"]' ).parent().addClass( 'checked' );
        $( '.resource-filter[value="'+ type_filter[ i ] +'"]' ).prop( 'checked', true );
      }
    }
    if ( typeof cat_filter === 'object' && cat_filter.length !== null ) {
      var catLength = cat_filter.length;
      for ( var i = 0; i < catLength; i++ ) {
        $( '.resource-filter[value="'+ cat_filter[ i ] +'"]' ).parent().addClass( 'checked' );
        $( '.resource-filter[value="'+ cat_filter[ i ] +'"]' ).prop( 'checked', true );
      }
    }

    /* Checkbox business logic */

    $( document ).on( 'ifToggled', '.icheckbox', function( event ) {

      $( this ).hasClass( 'checked' ) ? $( this ).children( '.resource-filter' ).prop( 'checked', false ) : $( this ).children( '.resource-filter' ).prop( 'checked', true );

      var topic = [];
      $( 'input[name="group[]"]:checkbox:checked' ).each( function( i ) {
        topic[ i ] = $( this ).val();
      });
      topic = topic.toString();
      topic = topic.replace( /,/g, ',' );

      var topics = [];
      $( 'input[name="group[]"]' ).each( function( i ) {
        topics[ i ] = $( this ).val();
      });

      var allTopics = topics.toString();
      allTopics = allTopics.replace( /,/g, ',' );

      topic.length === 0 ? topic = allTopics : topic;

      var mediaType = [];
      $( 'input[name="year[]"]:checkbox:checked' ).each( function( i ) {
        mediaType[ i ] = $( this ).val();
      });

      mediaType.join( ',' );

      var medias = [];
      $( 'input[name="year[]"]' ).each( function( i ) {
        medias[ i ] = $( this ).val();
      });

      medias.join( ',' );

      mediaType.length === 0 ? mediaType = medias : mediaType;

      mediaType = mediaType.toString();

      offset = 0;

      // mediaType = year
      // topic = group

      $( '.loading-results' ).show();
      SECsearch( 0, mediaType, topic, null, false );

    });


    /* Search reset business logic */


    $( '.clear-posts' ).click( function() {

      $( '.icheckbox' ).removeClass( 'checked' );
      $( '.icheckbox .resource-filter' ).prop( 'checked', false );

      offset = 0;

      SECsearch( 0, medias, allTopics, null, false );

    });

    }


    // PUBLIC METHODS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    return {

      init: _init

    };

  })();

